var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45mm",
    height: "33mm",
    viewBox: "0 0 45 33",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-27 -58.657)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m52.5 62.136c5 3 9.2948 7.4653 16 9 0 0 2 0.25986 2 2s-2 2-2 2l-10-2e-6",
    fill: "#f60",
    stroke: "#304376",
    strokeLinejoin: "round",
    strokeOpacity: 0.94118,
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m58.5 90.136h-30l2e-6 -15c2e-6 -10 5-15 15-15s15 5 15 15l-15 1e-6c10-1.6e-5 15 5 15 15z",
    fill: "#fc0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m49.5 61.136c-10 0-16 3.9166-16 13.958 2e-6 5.0209-4.6772 6.4223-4.6772 6.4223l-1.3228-4.3806s1 15 1-2 21-14 21-14z",
    fill: "#d4aa00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m58.5 90.136h-30l2e-6 -15c2e-6 -10 5-15 15-15 10 0 15 5 15 15l-15 1e-6c10-1.6e-5 15 5 15 15z",
    fill: "none",
    stroke: "#304376",
    strokeLinejoin: "round",
    strokeOpacity: 0.94118,
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m43.5 85.136v5",
    fill: "none",
    stroke: "#304376",
    strokeLinecap: "round",
    strokeOpacity: 0.94118,
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    d: "m46.5 64.136a3 3 0 0 0-2.9998 3.0003 3 3 0 0 0 2.9998 2.9998 3 3 0 0 0 2.883-2.1792 1.125 1.125 0 0 1-0.88263 0.42943 1.125 1.125 0 0 1-1.125-1.125 1.125 1.125 0 0 1 1.125-1.125 1.125 1.125 0 0 1 0.96273 0.54467 3 3 0 0 0-2.9631-2.5451z",
    fill: "#304376",
    style: {
      paintOrder: "normal"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1ee692be.svg";
export { ForwardRef as ReactComponent };